import { AGGridWrapper } from "@/components/common/AGGridWrapper";
import { getAgGridFormatters } from "@/components/common/AGGridWrapper/getAgGridFormatters";
import { VStack } from "@/components/sgBootstrapReactWrapper";
import type { SigmaOrderHistory } from "@/store/operations/model";
import type { ColDef } from "ag-grid-community";
import { useIntl } from "react-intl";

export type ArrayProps = {
  data: SigmaOrderHistory[];
  titleLabelId: string,
};

export default function SigmaOrderHistoryArray({ data, titleLabelId }: ArrayProps) {
  const { $t, locale } = useIntl();
  const agGridFormatters = getAgGridFormatters<SigmaOrderHistory>(locale);
  const columnDefinitions: ColDef<SigmaOrderHistory>[] = [
    {
      field: 'status',
      headerName: $t({ id: 'sigma.drawer.status' }),
      headerTooltip: $t({ id: 'sigma.drawer.status' }),
      cellClass: 'border-end text-start',
      minWidth: 120,
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['reset', 'apply'],
        closeOnApply: true,
        maxNumConditions: 1,
      },
      suppressHeaderFilterButton: false,
    },
    {
      field: 'agent',
      headerName: $t({ id: 'sigma.drawer.agent' }),
      headerTooltip: $t({ id: 'sigma.drawer.agent' }),
      cellClass: 'border-end text-start',
      minWidth: 120,
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['reset', 'apply'],
        closeOnApply: true,
        maxNumConditions: 1,
      },
      suppressHeaderFilterButton: false,
    },
    {
      field: 'dateTime',
      headerName: $t({ id: 'sigma.drawer.dateTime' }),
      headerTooltip: $t({ id: 'sigma.drawer.dateTime' }),
      cellClass: 'border-end text-start',
      valueFormatter: agGridFormatters.dateTime,
      minWidth: 120,
      filter: 'agDateColumnFilter',
      filterParams: {
        buttons: ['reset', 'apply'],
        closeOnApply: true,
        maxNumConditions: 1,
      },
      suppressHeaderFilterButton: false,
    },
  ];

  return <VStack>
    <AGGridWrapper
      identifier="sigmaOrderHistory"
      titleLabelId={titleLabelId}
      rowData={data}
      gridHeigth={300}
      columnDefs={columnDefinitions}
    />
  </VStack>
}